import type { MessageSendErrorCode } from '@teo/widget-shared';
import { WidgetUploadError } from './upload-thread-file.js';

/** Map upload/send failures to a stable UI error code. */
export function mapToMessageSendError(error: unknown): MessageSendErrorCode {
  if (error instanceof WidgetUploadError) {
    switch (error.code) {
      case 'TOO_LARGE':
        return 'too_large';
      case 'UNSUPPORTED_FORMAT':
        return 'unsupported';
      case 'UPLOAD_FAILED':
      case 'INVALID_RESPONSE':
        return 'upload';
      default:
        return 'generic';
    }
  }
  return 'generic';
}
